import {get,postJson,post} from '@/api/request/CommonRequest'
import axios from 'axios'
import { Message, Modal } from 'view-design'
import qs from 'qs'

export let zfglMethod_2_001 = {}

zfglMethod_2_001.selectList  = function (params) {
  return post('/house/selectList',params)
}

zfglMethod_2_001.getByIdforUpdate  = function (params) {
  return post('/house/getByIdforUpdate',params)
}

zfglMethod_2_001.getById  = function (params) {
  return post('/house/getById',params)
}
zfglMethod_2_001.getByFwdz  = function (params) {
  return post('/house/getByFwdz',params)
}

zfglMethod_2_001.insertRecord  = function (params) {
  return postJson('/house/insertRecord',params)
}

zfglMethod_2_001.updateRecord  = function (params) {
  return postJson('/house/updateRecord',params)
}

zfglMethod_2_001.getHousePhotosById  = function (params) {
  return post('/house/getHousePhotosById',params)
}


zfglMethod_2_001.deleteRecord  = function (params) {
  return post('/house/deleteRecord',params)
}

zfglMethod_2_001.hhzzOperate  = function (params) {
  return post('/house/hhzzOperate',params)
}

zfglMethod_2_001.insertFileRecord  = function (params) {
  return post('/api/file/insertFileRecord',params)
}

zfglMethod_2_001.selectKzzjRecord  = function (params) {
  return post('/house/selectKzzjRecord',params)
}

zfglMethod_2_001.changeUseBySelf  = function (params) {
  return post('/house/changeUseBySelf',params)
}

zfglMethod_2_001.operateXy  = function (params) {
  return post('/house/operate-xy',params)
}

zfglMethod_2_001.changeUseByHire  = function (params) {
  return post('/house/changeUseByHire',params)
}

zfglMethod_2_001.updateRecord  = function (params) {
  return postJson('/house/updateRecord',params)
}

zfglMethod_2_001.updateOtherInfo  = function (params) {
  return postJson('/house/updateOtherInfo',params)
}

zfglMethod_2_001.updateYwzt  = function (params) {
  return postJson('/house/updateYwzt',params)
}

zfglMethod_2_001.changeSfr  = function (params) {
  return postJson('/house/changeSfr',params)
}

zfglMethod_2_001.changeLzfp  = function (params) {
  return post('/house/changeLzfp',params)
}
zfglMethod_2_001.selectFyListWithPhoto  = function (params) {
  return post('/house/selectFyListWithPhoto',params)
}
zfglMethod_2_001.selectSffkjhList  = function (params) {
  return post('/house/selectSffkjhList',params)
}

zfglMethod_2_001.changeSffkZt  = function (params) {
  return post('/house/changeSffkZt',params)
}

zfglMethod_2_001.changeSjfk  = function (params) {
  return post('/house/changeSjfk',params)
}

zfglMethod_2_001.cfDczYd  = function (params) {
  return post('/house/cf-dcz/yd',params)
}

zfglMethod_2_001.addCffkjh  = function (params) {
  return postJson('/house/cf-dcz/addFkjl',params)
}

zfglMethod_2_001.selectCffkjh  = function (params) {
  return post('/house/cf-dcz/selectCffkjh',params)
}

zfglMethod_2_001.deleteCffkjh  = function (params) {
  return post('/house/cf-dcz/deleteCffkjh',params)
}

zfglMethod_2_001.exportBefore  = function (params) {
  return post('/table/exportBefore',params)
}

zfglMethod_2_001.operateWahckDetail  = function (params) {
  return post('/table/getById',params)
}


// loginMethod.login = function (params) {
//   return post('/user/login',params)
// }

// loginMethod.loginV2 = function (params) {
//   return post('/user/login_v2',params)
// }

